import { useState } from "react";
import "./StartExamContent.css";
import Logo from "../../../assets/logo.svg";
import { useNavigate } from "react-router-dom";
import { HomeRounded, ThumbDown, ThumbUp } from "@mui/icons-material";
import {
  Alert,
  Button,
  IconButton,
  Radio,
  Checkbox,
  Snackbar,
  Tooltip,
  Skeleton,
} from "@mui/material";

const ChoiceLoader = ({ count }) => {
  const safeCount = Number(count);
  return [...Array(safeCount)].map((_, i) => (
    <button
      disabled={true}
      onClick={() => {}}
      className="choices no-cap"
      key={i.toString()}
    >
      <p
        style={{
          marginBottom: "0rem",
          color: "#1e1e1e",
          display: "flex",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Radio
          color="black"
          sx={{ padding: "0px", marginRight: "0.5rem" }}
          size="small"
          checked={false}
          disabled={true}
        />

        <Skeleton
          variant="text"
          sx={{ fontSize: "1rem", width: "80%" }}
          height={20}
        />
      </p>
    </button>
  ));
};

const StartExamContent = (props) => {
  let choiceButtons = document.getElementsByClassName("choices");
  const [alertClass, setAlertClass] = useState("");
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [validateFunctionCalled, setValidateFunctionCalled] = useState(false);
  const [finalScore, setFinalScore] = useState(0);
  const [answers, setAnswers] = useState(); // Can be object or array
  const currentCount = props.currentQuestion + 1;
  const navigate = useNavigate();

  const isSelected = (item) => {
    if (Array.isArray(answers)) {
      return answers.some((a) => a.choice === item.choice);
    }
    return answers === item;
  };

  const handleSelect = (item) => {
    const type = props.allQuestions[props.currentQuestion].question_type;
    if (type === "MS") {
      const currentanswerss = Array.isArray(answers) ? [...answers] : [];
      const index = currentanswerss.findIndex((a) => a.choice === item.choice);
      if (index > -1) {
        currentanswerss.splice(index, 1);
      } else {
        currentanswerss.push(item);
      }
      setAnswers(currentanswerss);
    } else {
      setAnswers(item);
    }
  };

  function exitExam() {
    navigate("/exams");
  }

  async function setScore(revealed = false) {
    const type = props.allQuestions[props.currentQuestion].question_type;
    let isCorrect = false;
    const choiceIds = Array.isArray(answers)
      ? answers.map((item) => item.id)
      : [answers.id];
    if (type === "MS") {
      const choices = props.allQuestions[props.currentQuestion].choices;
      const correctChoices = choices.filter((c) => c.correct);
      isCorrect =
        Array.isArray(answers) &&
        answers.length === correctChoices.length &&
        answers.every((a) => a.correct);
    } else {
      isCorrect = answers && answers.correct;
    }
    if (isCorrect) {
      setAlertClass("correct");
      setShowSnackBar(true);
    } else {
      setAlertClass("incorrect");
      setShowSnackBar(true);
    }
    const examProgress = {
      question_id: props.allQuestions[props.currentQuestion].id,
      selected_choices: choiceIds,
      is_correct: isCorrect,
      revealed: revealed,
      index: props.currentQuestion,
      completed: currentCount === props.count,
    };

    props.updateProgress(examProgress);
  }

  async function validate() {
    setScore(true);
    for (let x = 0; x < choiceButtons.length; x++) {
      if (choiceButtons[x].id.includes("correct")) {
        choiceButtons[x].style.border = "var(--green) solid 1.5px";
      } else {
        choiceButtons[x].style.border = "var(--red) solid 1.5px";
      }
    }
    setValidateFunctionCalled(true);
  }

  function changeQuestion(currentIndex) {
    if (!validateFunctionCalled) setScore();
    if (currentCount === props.count) {
      if (!props.examId) {
        const encodedName = encodeURIComponent(props.examName);
        navigate(`/report/${encodedName}`, {
          state: {
            score: Math.round((props.finalScore / props.count) * 100) || 0,
            name: props.examName,
          },
        });
        return;
      }
      navigate(`/report/${props.examId}`);
    }
    setAnswers(undefined);
    setShowSnackBar(false);
    setValidateFunctionCalled(false);

    if (currentCount <= props.count) {
      const nextQuestion = currentIndex + 1;
      props.setCurrentQuestion(nextQuestion);
      for (let x = 0; x < choiceButtons.length; x++) {
        choiceButtons[x].style.border = "#c7c7c7 solid 1.5px";
      }
    }
  }

  function restartExam() {
    if (finalScore) setFinalScore(0);
    setAnswers(undefined);
    setAlertClass("");
    setShowSnackBar(false);
    props.setCurrentQuestion(0);
  }

  return (
    <div className="active-container page">
      <div className="around-active-exam">
        <div className="top-part">
          <img className="logo-image" src={Logo} alt="Assessive Logo" />
          <Tooltip title="Exit Exam" placement="left">
            <IconButton onClick={() => exitExam()} className="exit-button">
              <HomeRounded fontSize="medium" />
            </IconButton>
          </Tooltip>
        </div>
        {currentCount <= props.count && (
          <div className="middle-part">
            <h6 className="question">
              {props.loading ? (
                <>
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: "1rem", width: "80%" }}
                    height={20}
                  />
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: "1rem", width: "90%" }}
                    height={20}
                  />
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: "1rem", width: "70%" }}
                    height={20}
                  />
                </>
              ) : props.allQuestions[props.currentQuestion] ? (
                props.allQuestions[props.currentQuestion].question
              ) : (
                ""
              )}
            </h6>
            {props.loading ? (
              <ChoiceLoader count={4} />
            ) : (
              props.allQuestions[props.currentQuestion] &&
              props.allQuestions[props.currentQuestion].choices.map(
                (item, index) => {
                  const isChoiceSelected = isSelected(item);
                  const isMultipleSelect =
                    props.allQuestions[props.currentQuestion].question_type ===
                    "MS";

                  return (
                    <button
                      disabled={validateFunctionCalled}
                      onClick={() => handleSelect(item)}
                      className={`choices ${
                        isChoiceSelected ? "highlighted no-cap" : "no-cap"
                      }`}
                      id={`choice-${index}-${
                        item.correct ? "correct" : "wrong"
                      }`}
                      key={index.toString()}
                    >
                      <div>
                        <p
                          style={{
                            marginBottom: "0rem",
                            color: "#1e1e1e",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {isMultipleSelect ? (
                            <Checkbox
                              color="black"
                              sx={{
                                padding: "0px",
                                marginRight: "0.5rem",
                                color: "var(--borderColor)",
                              }}
                              size="small"
                              checked={isChoiceSelected}
                            />
                          ) : (
                            <Radio
                              color="black"
                              sx={{
                                padding: "0px",
                                marginRight: "0.5rem",
                                color: "var(--borderColor)",
                              }}
                              size="small"
                              checked={isChoiceSelected}
                            />
                          )}
                          {item.choice}
                        </p>
                      </div>
                    </button>
                  );
                },
              )
            )}
          </div>
        )}

        <div className="bottom-part">
          <Button
            onClick={() => validate()}
            color="ghostBlue2"
            variant="contained"
            disableElevation
            disabled={
              !answers ||
              (Array.isArray(answers) && answers.length === 0) ||
              validateFunctionCalled
            }
          >
            check
          </Button>
          <h6
            style={{
              marginBottom: "0rem",
              color: "white",
              textTransform: props.loading ? "capitalize" : "lowercase",
            }}
          >
            {props.loading
              ? "Loading..."
              : `${Math.min(currentCount, props.count)} of ${props.count}`}
          </h6>
          {currentCount <= props.count ? (
            <Button
              disableElevation
              onClick={() => changeQuestion(props.currentQuestion)}
              color="ghostBlue2"
              variant="contained"
              disabled={
                (!answers ||
                  (Array.isArray(answers) && answers.length === 0)) &&
                !validateFunctionCalled
              }
            >
              continue
            </Button>
          ) : (
            <Button
              onClick={() => restartExam()}
              color="ghostBlue2"
              variant="contained"
              disableElevation
              disabled={props.loading}
            >
              try again
            </Button>
          )}
        </div>
      </div>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={showSnackBar}
        onClose={(event, reason) => {
          if (reason === "clickaway") return;
          setShowSnackBar(false);
        }}
        message={alertClass}
        ContentProps={{
          className: `snack-bar ${alertClass}`,
        }}
      >
        <Alert
          severity={alertClass === "correct" ? "success" : "error"}
          variant="filled"
          sx={{ textTransform: "capitalize" }}
          iconMapping={{
            success: <ThumbUp fontSize="inherit" />,
            error: <ThumbDown fontSize="inherit" />,
          }}
        >
          {alertClass}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default StartExamContent;
